module.exports = __webpack_public_path__ + "929fd78b1498549427891f76ea0f1e51.ttf";